"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMediaScreenWithPublishingChannelsResponseForPlayer = exports.isMediaScreenWithPlaylistResponseForPlayer = exports.isPriceScreenResponseForPlayer = exports.WifiNetworkStatus = exports.EthernetNetworkStatus = exports.ScreenWarningType = exports.WarningPriority = exports.ScreenStatus = exports.ScreenProperty = exports.ScreenType = void 0;
var ScreenType;
(function (ScreenType) {
    /** Media always enabled */
    ScreenType["media"] = "media";
    ScreenType["price"] = "price";
})(ScreenType = exports.ScreenType || (exports.ScreenType = {}));
/**
 * Properties used to search screens by in invokable functions
 */
var ScreenProperty;
(function (ScreenProperty) {
    ScreenProperty["channelIds"] = "channelIds";
    ScreenProperty["listId"] = "listId";
    ScreenProperty["playlistId"] = "playlistId";
    ScreenProperty["defaultMedia"] = "defaultMedia";
    /** to get screens by location id */
    ScreenProperty["locationId"] = "locationId";
})(ScreenProperty = exports.ScreenProperty || (exports.ScreenProperty = {}));
var ScreenStatus;
(function (ScreenStatus) {
    /** Media always enabled */
    ScreenStatus["online"] = "online";
    /** screen is offline in ON/OFF timers range */
    ScreenStatus["offline"] = "offline";
    /** screen is offline outside of ON/OFF timers range */
    ScreenStatus["standby"] = "standby";
    /** screen is not yet linked to any player */
    ScreenStatus["notLinked"] = "notLinked";
})(ScreenStatus = exports.ScreenStatus || (exports.ScreenStatus = {}));
var WarningPriority;
(function (WarningPriority) {
    WarningPriority[WarningPriority["low"] = 1] = "low";
    WarningPriority[WarningPriority["medium"] = 2] = "medium";
    WarningPriority[WarningPriority["high"] = 3] = "high";
    WarningPriority[WarningPriority["emergency"] = 99] = "emergency";
})(WarningPriority = exports.WarningPriority || (exports.WarningPriority = {}));
var ScreenWarningType;
(function (ScreenWarningType) {
    ScreenWarningType["onOffTimerMissing"] = "onOffTimerMissing";
    /** screen has on/off timers and is not online inside timers range so it should be online */
    ScreenWarningType["shouldBeOnline"] = "shouldBeOnline";
    ScreenWarningType["shutdownTooEarly"] = "shutdownTooEarly";
    /** screen does not have on/off timers but last contact is over days old */
    ScreenWarningType["tooLongOffline"] = "tooLongOffline";
    /** wifi signal strength is poor  */
    ScreenWarningType["poorWifi"] = "poorWifi";
    /** Screen free space if running out */
    ScreenWarningType["lowStorageSpace"] = "lowStorageSpace";
    /** Screen does not have any selected content to play */
    ScreenWarningType["noContent"] = "noContent";
    /** Screen has old SeeSignage player version */
    ScreenWarningType["oldVersion"] = "oldVersion";
})(ScreenWarningType = exports.ScreenWarningType || (exports.ScreenWarningType = {}));
var EthernetNetworkStatus;
(function (EthernetNetworkStatus) {
    EthernetNetworkStatus["DEACTIVATED"] = "DEACTIVATED";
    EthernetNetworkStatus["DISCONNECTED"] = "DISCONNECTED";
    EthernetNetworkStatus["CONNECTED"] = "CONNECTED";
})(EthernetNetworkStatus = exports.EthernetNetworkStatus || (exports.EthernetNetworkStatus = {}));
var WifiNetworkStatus;
(function (WifiNetworkStatus) {
    WifiNetworkStatus["ON"] = "ON";
    WifiNetworkStatus["OFF"] = "OFF";
})(WifiNetworkStatus = exports.WifiNetworkStatus || (exports.WifiNetworkStatus = {}));
exports.isPriceScreenResponseForPlayer = (screenResponse) => {
    var _a, _b;
    return screenResponse.type === ScreenType.price && ((_a = screenResponse.listItem) === null || _a === void 0 ? void 0 : _a.template) &&
        (screenResponse.listItem.products || ((_b = screenResponse.listItem) === null || _b === void 0 ? void 0 : _b.lunchListItems));
};
exports.isMediaScreenWithPlaylistResponseForPlayer = (screenResponse) => screenResponse.type === ScreenType.media &&
    screenResponse.playlistId &&
    screenResponse.playlist &&
    screenResponse.channels === undefined;
exports.isMediaScreenWithPublishingChannelsResponseForPlayer = (screenResponse) => screenResponse.type === ScreenType.media && screenResponse.channels && screenResponse.channelIds;
//# sourceMappingURL=screens.js.map